import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/node/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/node/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/node/app/node_modules/normalize.css/normalize.css");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-acs.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-aon.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-aur.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-bas.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-beam.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-bgc.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-chl.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-coder-dojo.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-cro.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-opr.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-par.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-str.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/assets/charity-svgs/logo-wck.svg");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/Copyright/Copyright.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/Button/Button.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/CompanyQuote/CompanyQuote.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/components/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/HomeFooter/HomeFooter.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/Layout/Layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/components/LegalPopup/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/PageHeader/PageHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/PageDetails/PageDetails.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/GlobalPresence/GlobalPresence.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/LogoGrid/LogoGrid.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/RichText/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/containers/About/Charity/Charity.module.scss");
